import { apiClient } from 'container/apiClient';
import { SummaryApi } from 'api/SummaryApi';

export const summaryApi = new SummaryApi(apiClient);
